export const US_STATES = [
  { code: 'AL', name: 'Alabama' }, { code: 'AK', name: 'Alaska' }, { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' }, { code: 'CA', name: 'California' }, { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' }, { code: 'DE', name: 'Delaware' }, { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' }, { code: 'HI', name: 'Hawaii' }, { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' }, { code: 'IN', name: 'Indiana' }, { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' }, { code: 'KY', name: 'Kentucky' }, { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' }, { code: 'MD', name: 'Maryland' }, { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' }, { code: 'MN', name: 'Minnesota' }, { code: 'MS', name: 'Mississippi' },
  { code: 'MO', name: 'Missouri' }, { code: 'MT', name: 'Montana' }, { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' }, { code: 'NH', name: 'New Hampshire' }, { code: 'NJ', name: 'New Jersey' },
  { code: 'NM', name: 'New Mexico' }, { code: 'NY', name: 'New York' }, { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' }, { code: 'OH', name: 'Ohio' }, { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' }, { code: 'PA', name: 'Pennsylvania' }, { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' }, { code: 'SD', name: 'South Dakota' }, { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' }, { code: 'UT', name: 'Utah' }, { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' }, { code: 'WA', name: 'Washington' }, { code: 'WV', name: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin' }, { code: 'WY', name: 'Wyoming' },
];

export const EDUCATION_LEVELS = [
  'High School / GED',
  "Associate's Degree",
  "Bachelor's Degree",
  "Master's Degree",
  'Doctoral Degree (PhD, EdD, etc.)',
  'Professional Degree (JD, MD, etc.)',
  'Other',
];

export const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

const currentYear = new Date().getFullYear();
export const YEARS = Array.from({ length: 50 }, (_, i) => currentYear - i);

export const INDUSTRIES = [
  'Accounting & Finance',
  'Audit & Assurance',
  'Banking & Financial Services',
  'Consulting',
  'Education',
  'Government & Public Sector',
  'Healthcare',
  'Insurance',
  'Legal',
  'Manufacturing',
  'Non-Profit',
  'Real Estate',
  'Technology',
  'Other',
];

export const INTEREST_SUGGESTIONS = [
  'Auditing', 'Tax Planning', 'Financial Reporting', 'Ethics', 'Fraud & Forensics',
  'Governmental Accounting', 'Non-Profit Accounting', 'Technology & IT', 'Management Accounting',
  'International Accounting', 'Personal Financial Planning', 'Business Valuation',
];

/** A saved work-history entry mapped from the backend DTO into month/year form fields. */
export interface WorkEntry {
  backendId: string;
  companyName: string;
  jobTitle: string;
  industry: string;
  startMonth: string;
  startYear: string;
  isCurrent: boolean;
  endMonth: string;
  endYear: string;
  description: string;
}
